/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { AbstractRestService, optimisticLockingOf, RestSettings } from '@gh/core-data';
import { Observable } from 'rxjs';
import { HelpBugMapper } from './help-mapper';
import { HelpRequestDto } from './help.dto';

@Injectable()
export class HelpRestService extends AbstractRestService {
  constructor(settings: RestSettings) {
    super(settings);
  }

  create(details: HelpRequestDto): Observable<HelpRequestDto> {
    return this.httpPost(`${this.bp}/help/report`, details, optimisticLockingOf(HelpBugMapper));
  }
}
